module.exports = __webpack_public_path__ + "img/marthas-egg-white-bites.dd540174.jpg";